import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const StoreOrdersFinanceSection = "/reports/finance/store-orders";

export const StoreOrdersFinanceListPath = StoreOrdersFinanceSection;

export enum StoreOrdersFinanceListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType",
  isPayoutEligible = "isPayoutEligible",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  orderCanceledFrom = "orderCanceledFrom",
  orderCanceledTo = "orderCanceledTo",
  paymentMethodType = "paymentMethodType"
}

export enum StoreOrdersFinanceListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  orderStatus = "orderStatus",
  deliveryType = "deliveryType"
}

export type StoreOrdersFinanceListUrlDialog = "download" | TabActionDialog;
export type storeOrdersFinanceListUrlFilters = Filters<
  StoreOrdersFinanceListUrlFiltersEnum
> &
  FiltersWithMultipleValues<StoreOrdersFinanceListUrlFiltersWithMultipleValues>;

export type StoreOrdersFinanceUrlQueryParams = ActiveTab &
  storeOrdersFinanceListUrlFilters &
  BulkAction &
  Dialog<StoreOrdersFinanceListUrlDialog> &
  Pagination &
  SingleAction;

export const storeOrdersFinanceListUrl = (
  params?: StoreOrdersFinanceUrlQueryParams
) => StoreOrdersFinanceListPath + "?" + stringifyQs(params);
